import React, { useState } from "react";
import CampanasSeccion from "./CampanasSeccion";
import ClientesTab from "./ClientesTab";
import { ClientesApiContext, clientesAdapter } from "./clientesApi";
import "../reservas/reservas-organizer.css";
import "./clientes.css";

/* Módulo "Clientes" del panel (/organizer/clientes): las fichas del negocio, compartidas entre salón, club y bar.
   Habla con /api/organizer/clients (por negocio, sin salón) y muestra el historial de todos los rubros. */

const SECCIONES = [
  { key: "lista", label: "Clientes" },
  { key: "campanas", label: "Campañas" },
];

const ClientesOrganizer = () => {
  const [seccion, setSeccion] = useState("lista");
  return (
    <ClientesApiContext.Provider value={clientesAdapter}>
      <div className="zr-app zr-main">
        <div className="zr-tabs" role="tablist" aria-label="Secciones de clientes">
          {SECCIONES.map(({ key, label }) => (
            <button
              key={key}
              type="button"
              role="tab"
              aria-selected={seccion === key}
              className={`zr-tabs__item${seccion === key ? " zr-tabs__item--active" : ""}`}
              onClick={() => setSeccion(key)}
            >
              {label}
            </button>
          ))}
        </div>
        {/* The list stays mounted (hidden) so the search and the open record survive a trip to Campañas. */}
        <div hidden={seccion !== "lista"}>
          <ClientesTab
            barra={(fichaAbierta, cerrarFicha) =>
              fichaAbierta ? (
                <div className="zr-backbar">
                  <button type="button" className="zr-btn zr-btn--soft" onClick={cerrarFicha}>Volver a clientes</button>
                </div>
              ) : (
                <div className="zr-subhead">
                  <h2 className="zr-subhead__title">Clientes</h2>
                  <p className="zr-subhead__hint">Fichas, notas y el historial de cada cliente en tu salón, club y bar.</p>
                </div>
              )
            }
          />
        </div>
        {seccion === "campanas" && <CampanasSeccion />}
      </div>
    </ClientesApiContext.Provider>
  );
};

export default ClientesOrganizer;
